<template>
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.23977 1.32031C5.11305 1.32031 1.75977 4.67359 1.75977 8.80031C1.75977 12.927 5.11305 16.2803 9.23977 16.2803C10.8726 16.2803 12.3816 15.7544 13.6123 14.8641L19.401 20.6391L20.6385 19.4016L14.9185 13.6678C16.0426 12.3581 16.7198 10.6583 16.7198 8.80031C16.7198 4.67359 13.3665 1.32031 9.23977 1.32031ZM9.23977 2.20031C12.8904 2.20031 15.8398 5.14969 15.8398 8.80031C15.8398 12.4509 12.8904 15.4003 9.23977 15.4003C5.58914 15.4003 2.63977 12.4509 2.63977 8.80031C2.63977 5.14969 5.58914 2.20031 9.23977 2.20031Z"
            fill="black"
        />
    </svg>
</template>
